<template>
  <div class="advantages-list">
    <div v-for="item in list" :key="item.title" class="advantages-item">
      <img :data-src="item.img" alt="" width="132" height="133" class="lazyload">
      <h3 class="advantages-item__title">
        {{ item.title }}
      </h3>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdvantagesList',
  props: {
    list: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped lang="scss">
.advantages-list {
  @apply flex lg:flex-row flex-col justify-between lg:space-x-6 lg:space-y-0 space-y-12;
  .advantages-item {
    @apply flex flex-col items-center justify-center;
    &__title {
      @apply lg:text__body-1-md--regular text__body-2-xs--regular mt-6 text-center text-body-1;
    }
  }
}
</style>
